import { Background } from "../components/landing/Background";
import { Nav } from "../components/landing/Nav";
import { Hero } from "../components/landing/Hero";
import { Ribbon } from "../components/landing/Ribbon";
import { Story } from "../components/landing/Story";
import { Manifesto } from "../components/landing/Manifesto";
import { AudioPlayer } from "../components/landing/AudioPlayer";
import { Showcase } from "../components/landing/Showcase";
import { Testimonials } from "../components/landing/Testimonials";
import { TrialCTA } from "../components/landing/TrialCTA";
import { Download } from "../components/landing/Download";
import { Footer } from "../components/landing/Footer";
import { useEffect } from "react";
import { trackPageView } from "../lib/track";

export default function Landing() {
  useEffect(() => {
    trackPageView();
  }, []);

  return (
    <div className="grain relative min-h-screen bg-[#0a0a0c]" data-testid="landing-page">
      <Background />
      <Nav />
      <main className="relative z-10">
        <Hero />
        <Ribbon />
        <Story />
        <TrialCTA />
        <Manifesto />
        <AudioPlayer />
        <Showcase />
        <Testimonials />
        <Download />
      </main>
      <Footer />
    </div>
  );
}
